import React from 'react'

const GroupingIcon = ({width = 16, height = 16}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M7.99992 1.33334L4.33325 7.33334H11.6666L7.99992 1.33334Z" fill="#1D2331" />
      <path
        d="M11.6667 14.6667C13.3236 14.6667 14.6667 13.3235 14.6667 11.6667C14.6667 10.0098 13.3236 8.66666 11.6667 8.66666C10.0099 8.66666 8.66675 10.0098 8.66675 11.6667C8.66675 13.3235 10.0099 14.6667 11.6667 14.6667Z"
        fill="#1D2331"
      />
      <path d="M2 9H7.33333V14.3333H2V9Z" fill="#1D2331" />
    </svg>
  )
}

export default GroupingIcon
